export const ubuntuDesktop = {
        name: "Ubuntu Desktop",
        ide2: "ISO:iso/ubuntu-20.04.3-desktop-amd64.iso,media=cdrom",
        pool: "",
        ostype: "l26",
        scsihw: "virtio-scsi-pci",
        sockets: "1",
        sata0: "PoolAlumnat:20",
        cores: "4",
        memory: "2048",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};

export const windowsServer = {
        name: "Windows Server 2019",
        ide2: "ISO:iso/17763.737.190906-2324.rs5_release_svc_refresh_SERVER_EVAL_x64FRE_es-es_1.iso,media=cdrom",
        pool: "",
        ostype: "win10",
        scsihw: "virtio-scsi-pci",
        sockets: "1",
        sata0: "PoolAlumnat:30",
        cores: "4",
        memory: "4096",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};

export const windows10 = {
        name: "Windows 10",
        ide2: "ISO:iso/Win10_21H2_Spanish_x64.iso,media=cdrom",
        pool: "",
        ostype: "win10",
        scsihw: "virtio-scsi-pci",
        sockets: "1",
        sata0: "PoolAlumnat:30",
        cores: "4",
        memory: "8192",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};


export const pfSense = {
        name: "Pfsense",
        ide2: "ISO:iso/pfSense-CE-2.5.2-RELEASE-amd64.iso,media=cdrom",
        pool: "",
        ostype: "l26",
        scsihw: "virtio-scsi-pci",
        sockets: "1",
        sata0: "PoolAlumnat:12",
        cores: "4",
        memory: "2048",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};

export const ubuntuServer = {
        name: "Ubuntu Server",
        ide2: "ISO:iso/ubuntu-20.04.6-live-server-amd64.iso,media=cdrom",
        pool: "",
        ostype: "l26",
        scsihw: "virtio-scsi-pci",
        sockets: "1",
        sata0: "PoolAlumnat:20",
        cores: "4",
        memory: "4096",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};
export const ubuntuDesktop24 = {
        name: "Ubuntu Desktop 24",
        ide2: "ISO:iso/ubuntu-24.04.3-desktop-amd64.iso,media=cdrom",
        pool: "",
        ostype: "l26",
        scsihw: "virtio-scsi-pci",
        sockets: "2",
        sata0: "PoolAlumnat:20",
        cores: "2",
        memory: "2048",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};
export const ubuntuServer24 = {
        name: "Ubuntu Server 24",
        ide2: "ISO:iso/ubuntu-24.04.3-live-server-amd64.iso,media=cdrom",
        pool: "",
        ostype: "l26",
        scsihw: "virtio-scsi-pci",
        sockets: "2",
        sata0: "PoolAlumnat:20",
        cores: "2",
        memory: "2048",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};

export const windowsServer2025 = {
        name: "Windows Server 2025",
        ide2: "ISO:iso/26100.32230.260111-0550.lt_release_svc_refresh_SERVER_EVAL_x64FRE_es-es.iso,media=cdrom",
        pool: "",
        ostype: "win11",
        scsihw: "virtio-scsi-pci",
        sockets: "1",
        sata0: "PoolAlumnat:40",
        cores: "4",
        memory: "8192",
        net0: "",
        balloon: "2048",
        vga: "type=std,memory=32",
};

export const windows11 = {
        name: "Windows 11",
        ide2: "ISO:iso/Win11_25H2_Spanish_x64_v2.iso,media=cdrom",
        pool: "",
        ostype: "win11",
        scsihw: "virtio-scsi-pci",
        sockets: "1",
        sata0: "PoolAlumnat:40",
        cores: "4",
        memory: "8192",
        net0: "",
        balloon: "1024",
        vga: "type=std,memory=32",
};
